var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"text-justify",attrs:{"id":"df-news"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/cepSuites/new-logo.png"),"alt":"new-logo"}}),_c('p',[_vm._v(" "+_vm._s(_vm.$t("content"))+" ")]),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/news/logoinfo.png"),"alt":"logoinfo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }